var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "e-filters",
        {
          ref: "filters",
          attrs: {
            title: _vm.$t("Filtros"),
            searching: _vm.fetching,
            "show-search-button": false,
          },
          on: { reset: _vm.resetFilters },
          scopedSlots: _vm._u([
            {
              key: "after_buttons",
              fn: function () {
                return [
                  _c("e-button", {
                    staticClass: "ml-1 btn-sm-block",
                    attrs: {
                      id: "download",
                      variant: "primary",
                      icon: "download",
                      busy: _vm.fetching,
                      text: _vm.$t("Baixar Relatório"),
                    },
                    on: { click: _vm.downloadReport },
                  }),
                  _c("a", {
                    ref: "downloadLink",
                    staticStyle: { display: "none" },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("e-store-combo", {
                    attrs: {
                      id: "filter-stores",
                      required: false,
                      multiple: true,
                      placeholder: _vm.$t("Todas"),
                    },
                    model: {
                      value: _vm.filters.storeIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "storeIds", $$v)
                      },
                      expression: "filters.storeIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "filter-account-type",
                      type: "vue-select",
                      label: _vm.$t("Tipo de conta"),
                      placeholder: _vm.$t("Selecione"),
                      options: _vm.checkingAccountFilterTypeOptions(),
                      validation: "required",
                    },
                    model: {
                      value: _vm.filters.accountType,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "accountType", $$v)
                      },
                      expression: "filters.accountType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "filter-period",
                      type: "date-range-picker",
                      label: _vm.$t("Período"),
                      "time-picker": false,
                      validation: "required",
                    },
                    model: {
                      value: _vm.filters.period,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "period", $$v)
                      },
                      expression: "filters.period",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }